import React from "react";

import cn from "classnames";
import { useIntl } from "react-intl";

import Email from "@mapmycustomers/shared/types/email/Email";

import styles from "./SentEmailSubject.module.scss";

interface SentEmailSubjectProps {
  className?: string;
  subject: Email["subject"];
}

const SentEmailSubject = ({ className, subject }: SentEmailSubjectProps) => {
  const intl = useIntl();

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.subject}>
        {intl.formatMessage({
          id: "email.sentEmailSubject.subject",
          defaultMessage: "Subject",
          description: "Email subject",
        })}
      </div>
      <div>{subject}</div>
    </div>
  );
};

export default SentEmailSubject;
